import { Navigate } from 'react-router-dom';
import { DOCS_DEFAULT_SLUG } from '../../config/docsNav';
import { DOCS_PATH } from '../../config/paths';

const DocsIndexRedirect = () => (
    <Navigate to={`${DOCS_PATH}/${DOCS_DEFAULT_SLUG}`} replace />
);

export default DocsIndexRedirect;
